export const LWF_INITIAL_STATE = {
    employee_contribution: "",
    employer_contribution: "",
    deduction_type: "",
    state_id: 5
}

